import '@vaadin/popover/src/vaadin-popover';
import './descope-calendar';
import '../descope-text-field';

import { componentName, DateFieldClass } from './DateFieldClass';

customElements.define(componentName, DateFieldClass);

export { DateFieldClass, componentName };
